export const exists = (flags = {}, slug = '') =>
  Object.prototype.hasOwnProperty.call(flags, slug) && flags[slug] !== null;

export const isEnabled = (flags = {}, slug = '') => {
  if (['b', 'feature_b', 'ON'].includes(flags[slug])) {
    return true;
  }
  if (['a', 'feature_a', 'OFF'].includes(flags[slug])) {
    return false;
  }
  return Boolean(flags[slug]);
};

export default { exists, isEnabled };
